import {
  Modal,
  Form,
  Input,
  Button,
  Select,
  message,
  Tabs,
  Checkbox,
} from 'antd';
import React, { useState } from 'react';
import operatorsApi from '../../api/operators';
import IntlMessage from '../../components/IntlMessage';
import CountryData from '../../utils/countrydata';
import IntlMessages from '../../components/IntlMessage';

const opearator_user_roles = [
  {
    id: 1,
    role: 'cashier',
    attributes: ['agent_app'],
  },
  {
    id: 2,
    role: 'convoyeur',
    attributes: ['passenger_list'],
  },
  {
    id: 3,
    role: 'partner_manager',
    attributes: ['bookings', 'passenger_list', 'finance', 'report'],
  },
  {
    id: 4,
    role: 'partner_admin',
    attributes: [
      'bookings',
      'passenger_list',
      'finance',
      'report',
      'create_account',
      'add_departure',
    ],
  },
];
const AddUserOperatorForm = (props) => {
  const [form] = Form.useForm();
  const {
    open,
    onClose,
    onReload,
    currentData,
    data: data_operator,
    userOprator,
  } = props;
  const onFinish = (values) => {
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  let initialValues = {
    firstname:
      currentData && currentData.firstname ? currentData.firstname : null,
    lastname: currentData && currentData.lastname ? currentData.lastname : null,
    username: currentData && currentData.username ? currentData.username : null,
    email: currentData && currentData.email ? currentData.email : null,
    mobile: currentData && currentData.mobile ? currentData.mobile : null,
    status: currentData && currentData.status ? 1 : 0,
    role:
      userOprator && userOprator.params
        ? JSON.parse(userOprator.params)?.role
        : null,
    attribute:
      userOprator && userOprator.params
        ? JSON.parse(userOprator.params)?.attribute
        : null,
  };

  console.log("form.getFieldValue('role') ", initialValues);
  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        if (!values.role && !currentData) {
          message.error('Veuillez sélectionner un rôle');
          return;
        }
        let data = { ...values };
        data.operator_id = data_operator.id;
        if (data.role) {
          data.params = JSON.stringify({
            role: data.role,
            attribute: data.attribute,
          });
        }
        if (!data?.password) {
          delete data.password;
        }
        if (data.role) {
          delete data.role;
        }
        if (data.attribute) {
          delete data.attribute;
        }
        if (currentData) {
          const res = await operatorsApi.updateUserOperator(
            currentData.id,
            data,
          );
          console.log('data123 :', data);

          if (res) {
            message.success('Successfully updated!');
            onClose();
            onReload();
          }
        } else {
          const res = await operatorsApi.createUserOperator(data);
          if (res) {
            message.success('Successfully created!');
            onClose();
            onReload();
          }
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
        message.error(
          info?.data?.message || 'Veuillez vérifier les champs du formulaire',
        );
      });
  };

  const [role, setRole] = useState(null);

  const onChangeRole = (role) => {
    setRole(role);
    form.setFieldValue(
      'attribute',
      opearator_user_roles.find((i) => i.role === role).attributes,
    );
  };
  const roleValue = Form.useWatch('role', form);
  const tabItems = [
    {
      key: '1',
      label: <IntlMessages id="global.agent" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id="global.firstname" />}
            name="firstname"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_firstname" />,
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            label={<IntlMessage id="global.lastname" />}
            name="lastname"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_lastname" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.phone_code" />}
            name={'phone_code'}
            initialValue={'+221'}>
            <Select
              style={{ width: '100%' }}
              placeholder="Select phone code"
              showSearch
              defaultValue={`+221`}
              options={CountryData.map((country, i) => {
                return {
                  label: `(+${country.code}) ${country.country}`,
                  value: `+${country.code}`,
                };
              })}
            />
          </Form.Item>

          <Form.Item
            label={<IntlMessage id="global.mobile" />}
            name="mobile"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_mobile" />,
              },
              {
                message: <IntlMessage id={`validate.is_not_phone_number`} />,
                pattern: new RegExp(/^[0-9]+$/),
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_email" />,
              },
              {
                type: 'email',
                message: <IntlMessage id="validate.is_not_email" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.password" />}
            name="password"
            rules={[
              {
                required: currentData ? false : true,
                message: <IntlMessage id="global.required_field_password" />,
              },
            ]}>
            <Input.Password />
          </Form.Item>
        </>
      ),
    },
    {
      key: '2',
      label: <IntlMessages id="global.roles" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id={`global.role`} />}
            labelCol={{ span: 4 }}
            name={'role'}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_role" />,
              },
            ]}>
            <Select
              style={{ width: 500 }}
              showSearch
              onChange={onChangeRole}
              filterOption={false}
              options={opearator_user_roles.map((item, i) => {
                return {
                  label: <IntlMessages id={`select.${item.role}`} />,
                  value: item?.role,
                };
              })}
            />
          </Form.Item>
          {roleValue && (
            <Form.Item
              label={<IntlMessages id="global.access" />}
              name="attribute"
              rules={[
                {
                  required: false,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <Checkbox.Group
                options={
                  opearator_user_roles.find((i) => i.role === roleValue)
                    .attributes || []
                }
                onChange={(value) => {
                  console.log('checked', value);
                }}
                style={{ flexDirection: 'column' }}
              />
            </Form.Item>
          )}
        </>
      ),
    },
  ];
  return (
    <React.Fragment>
      <Modal
        title={<IntlMessage id="global.add" />}
        open={open}
        onCancel={onClose}
        width={'50%'}
        footer={[
          <>
            <Button key="back" type="default" onClick={onClose}>
              {<IntlMessage id="global.cancel" />}
            </Button>
            <Button key="back" type="primary" onClick={handleOk}>
              {<IntlMessage id="global.save" />}
            </Button>
          </>,
        ]}>
        <Form
          // name="basic"
          {...layout}
          form={form}
          className="ml-20"
          initialValues={initialValues}
          labelAlign="left"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off">
          <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default AddUserOperatorForm;
